import React, { useState } from 'react';
import { Copy, Edit2, Printer, ChevronDown } from 'lucide-react';

import { DemoBanner } from './DemoBanner';

export function Supervision() {
  const [generated, setGenerated] = useState(true);
  const [selectedCount, setSelectedCount] = useState('1 сессия выбрана');

  return (
    <div className="space-y-4">
      <DemoBanner section="Для супервизии" />

      <div className="bg-white border border-gray-200 rounded-xl p-5 flex items-center gap-4">
        <span className="text-gray-400 text-sm" aria-hidden>
          ℹ
        </span>

        <div
          className="flex-1 border border-gray-200 rounded-lg px-4 py-2 flex items-center justify-between cursor-pointer hover:bg-gray-50"
          role="button"
          tabIndex={0}
          onClick={() => {
            setSelectedCount('1 сессия выбрана');
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') setSelectedCount('1 сессия выбрана');
          }}
        >
          <span className="text-sm text-gray-700">{selectedCount}</span>
          <ChevronDown size={14} className="text-gray-400" />
        </div>

        <button
          type="button"
          onClick={() => setGenerated((v) => !v)}
          className={`px-8 py-2.5 rounded-lg text-sm font-medium transition-colors ${
            generated ? 'bg-teal-400 text-white' : 'bg-[#C41230] text-white hover:bg-red-700'
          }`}
        >
          {generated ? 'Сгенерировано' : 'Генерировать'}
        </button>
      </div>

      {generated && (
        <div className="bg-white border border-gray-200 rounded-xl p-6">
          <div className="flex items-center justify-between mb-4 pb-4 border-b border-gray-100">
            <h3 className="text-xl font-semibold text-gray-900">Резюме для супервизии</h3>

            <div className="flex items-center gap-4">
              <button type="button" className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-800">
                <Edit2 size={14} /> Редактировать
              </button>
              <button type="button" className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-800">
                <Printer size={14} /> Печать
              </button>
              <button type="button" className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-800">
                <Copy size={14} /> Копировать
              </button>
            </div>
          </div>

          <div className="mb-4 pb-4 border-b border-gray-100">
            <p className="text-sm font-semibold text-gray-700 mb-2">На основе сессий:</p>
            <ul className="text-sm text-gray-600 space-y-1">
              <li>• Вторник, 17 декабря — Управление тревогой: новые стратегии самопомощи.</li>
            </ul>
          </div>

          <div className="space-y-6 text-sm text-gray-700">
            <section>
              <h4 className="font-bold text-gray-900 mb-2">
                Демографические данные (Dgr), Семейная констелляция (F), Проблема (PP), Релевантный анамнез (Hx)
              </h4>
              <p className="mb-1">Dgr: 26 лет, предприниматель, ГТР, владелец малого бизнеса</p>
              <p className="mb-1">F: Родители в разводе с детства, клиент брал роль опекуна для младшего брата</p>
              <p className="mb-1">PP: Рабочий стресс, трудности с самопомощью, баланс работы и жизни</p>
              <p>Hx: Эмоциональное пренебрежение в детстве, паттерны перфекционизма</p>
            </section>

            <section>
              <h4 className="font-bold text-gray-900 mb-2">
                Предъявляемые жалобы (S), Красные флаги (RF), Клинические интервенции (T/P), Рекомендации (Rx), Реакция клиента (R)
              </h4>
              <p className="mb-1">
                S: Фрустрация из-за некомпетентного ассистента, вина при установлении границ, 10% выполнение плана самопомощи.
              </p>
              <p className="mb-1">RF: Высокий уровень злости и фрустрации, фантазии о вербальной агрессии к сотруднику.</p>
              <p className="mb-1">
                T/P: Ролевая игра для профессиональной конфронтации. Терапевт направил клиента через структурированную обратную связь.
                Исследованы глубинные чувства (злость, тревога, поражение).
              </p>
              <p className="mb-1">
                Rx: Практика структурированного разговора с ассистентом с помощью шаблона ролевой игры. Чёткие ожидания и временные рамки.
              </p>
              <p>
                R: Изначально сопротивлялась (&quot;ваша идея с ролевой игрой - глупость&quot;), но включилась.
                Продемонстрировала готовность пробовать конструктивный подход.
              </p>
            </section>

            <section>
              <h4 className="font-bold text-gray-900 mb-2">Вопросы для супервизора</h4>
              <ul className="space-y-2">
                <li className="flex items-start gap-2">
                  <span className="text-gray-400 mt-0.5">•</span>
                  <span>Как более эффективно работать с сопротивлением клиента в начале сессии?</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-gray-400 mt-0.5">•</span>
                  <span>Стоит ли интенсифицировать работу с детскими паттернами привязанности?</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-gray-400 mt-0.5">•</span>
                  <span>Нужна ли дополнительная оценка рисков с учётом интенсивности злости клиента?</span>
                </li>
              </ul>
            </section>
          </div>
        </div>
      )}
    </div>
  );
}

